<script lang="ts">
  import * as components from 'customer-components';
  import * as marketingComponents from 'customer-components/lib/marketing';
  import { replaceMacros } from 'customer-components/lib/helpers/MacrosSystem';
  import type {
    GlobalProperties,
    UseFormattedProps,
    MktSettings,
  } from 'customer-components/lib/types';
  import { page } from '$app/stores';

  export let properties: UseFormattedProps;
  export let type = '';
  export let settings: GlobalProperties | MktSettings;
  export let isMarketingBlock = false;
  export let timeOutPopupVisible = null;
  export let disclaimer = null;
  export let isMobile = false;

  if ($page?.data?.city)
    settings.websiteData['locationCity'] = $page?.data?.city.Name;

  $: properties = settings?.websiteData
    ? replaceMacros(properties, settings?.websiteData, $page.url)
    : properties;
</script>

{#if isMarketingBlock}
  {#if marketingComponents[type]}
    <svelte:component
      this={marketingComponents[type]}
      {properties}
      {settings}
      {disclaimer}
      {timeOutPopupVisible}
      {isMobile}
    />
  {/if}
{:else if components[type]}
  <svelte:component this={components[type]} {properties} {settings} />
{/if}
